import { default as indexoWSP4Mlp0tMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/[roundId]/index.vue?macro=true";
import { default as resultsrGpI7VjNViMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/[roundId]/results.vue?macro=true";
import { default as indexGKUuunIXoYMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/index.vue?macro=true";
import { default as noneaa5sPph2jAMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/none.vue?macro=true";
import { default as profilewRJp75aciuMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/profile.vue?macro=true";
import { default as imagerEfTrpcaMoMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/admin/answer/[answerId]/image.vue?macro=true";
import { default as indexLt5S1saY5zMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/admin/index.vue?macro=true";
import { default as aggregateEBESsddj4jMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue?macro=true";
import { default as index0W04xg0OYUMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/index.vue?macro=true";
import { default as resultsFLs8SOlWMpMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/results.vue?macro=true";
import { default as _91roundId_93gOXfzZik9gMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue?macro=true";
import { default as createLnp3A3SH9WMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue?macro=true";
import { default as createy5OSSYznPFMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/create.vue?macro=true";
import { default as indexI29PzlnlzfMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/index.vue?macro=true";
import { default as logineGe6N4CpIoMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/login.vue?macro=true";
import { default as registerIENyPaptVvMeta } from "/codebuild/output/src2814414732/src/sense-us.app/pages/register.vue?macro=true";
export default [
  {
    name: indexoWSP4Mlp0tMeta?.name ?? "projectId-roundId___en",
    path: indexoWSP4Mlp0tMeta?.path ?? "/:projectId()/:roundId()",
    meta: indexoWSP4Mlp0tMeta || {},
    alias: indexoWSP4Mlp0tMeta?.alias || [],
    redirect: indexoWSP4Mlp0tMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexoWSP4Mlp0tMeta?.name ?? "projectId-roundId___nl",
    path: indexoWSP4Mlp0tMeta?.path ?? "/nl/:projectId()/:roundId()",
    meta: indexoWSP4Mlp0tMeta || {},
    alias: indexoWSP4Mlp0tMeta?.alias || [],
    redirect: indexoWSP4Mlp0tMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexoWSP4Mlp0tMeta?.name ?? "projectId-roundId___fr",
    path: indexoWSP4Mlp0tMeta?.path ?? "/fr/:projectId()/:roundId()",
    meta: indexoWSP4Mlp0tMeta || {},
    alias: indexoWSP4Mlp0tMeta?.alias || [],
    redirect: indexoWSP4Mlp0tMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexoWSP4Mlp0tMeta?.name ?? "projectId-roundId___de",
    path: indexoWSP4Mlp0tMeta?.path ?? "/de/:projectId()/:roundId()",
    meta: indexoWSP4Mlp0tMeta || {},
    alias: indexoWSP4Mlp0tMeta?.alias || [],
    redirect: indexoWSP4Mlp0tMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: resultsrGpI7VjNViMeta?.name ?? "projectId-roundId-results___en",
    path: resultsrGpI7VjNViMeta?.path ?? "/:projectId()/:roundId()/results",
    meta: resultsrGpI7VjNViMeta || {},
    alias: resultsrGpI7VjNViMeta?.alias || [],
    redirect: resultsrGpI7VjNViMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsrGpI7VjNViMeta?.name ?? "projectId-roundId-results___nl",
    path: resultsrGpI7VjNViMeta?.path ?? "/nl/:projectId()/:roundId()/results",
    meta: resultsrGpI7VjNViMeta || {},
    alias: resultsrGpI7VjNViMeta?.alias || [],
    redirect: resultsrGpI7VjNViMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsrGpI7VjNViMeta?.name ?? "projectId-roundId-results___fr",
    path: resultsrGpI7VjNViMeta?.path ?? "/fr/:projectId()/:roundId()/results",
    meta: resultsrGpI7VjNViMeta || {},
    alias: resultsrGpI7VjNViMeta?.alias || [],
    redirect: resultsrGpI7VjNViMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsrGpI7VjNViMeta?.name ?? "projectId-roundId-results___de",
    path: resultsrGpI7VjNViMeta?.path ?? "/de/:projectId()/:roundId()/results",
    meta: resultsrGpI7VjNViMeta || {},
    alias: resultsrGpI7VjNViMeta?.alias || [],
    redirect: resultsrGpI7VjNViMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: indexGKUuunIXoYMeta?.name ?? "projectId___en",
    path: indexGKUuunIXoYMeta?.path ?? "/:projectId()",
    meta: indexGKUuunIXoYMeta || {},
    alias: indexGKUuunIXoYMeta?.alias || [],
    redirect: indexGKUuunIXoYMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexGKUuunIXoYMeta?.name ?? "projectId___nl",
    path: indexGKUuunIXoYMeta?.path ?? "/nl/:projectId()",
    meta: indexGKUuunIXoYMeta || {},
    alias: indexGKUuunIXoYMeta?.alias || [],
    redirect: indexGKUuunIXoYMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexGKUuunIXoYMeta?.name ?? "projectId___fr",
    path: indexGKUuunIXoYMeta?.path ?? "/fr/:projectId()",
    meta: indexGKUuunIXoYMeta || {},
    alias: indexGKUuunIXoYMeta?.alias || [],
    redirect: indexGKUuunIXoYMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexGKUuunIXoYMeta?.name ?? "projectId___de",
    path: indexGKUuunIXoYMeta?.path ?? "/de/:projectId()",
    meta: indexGKUuunIXoYMeta || {},
    alias: indexGKUuunIXoYMeta?.alias || [],
    redirect: indexGKUuunIXoYMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: noneaa5sPph2jAMeta?.name ?? "projectId-none___en",
    path: noneaa5sPph2jAMeta?.path ?? "/:projectId()/none",
    meta: noneaa5sPph2jAMeta || {},
    alias: noneaa5sPph2jAMeta?.alias || [],
    redirect: noneaa5sPph2jAMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: noneaa5sPph2jAMeta?.name ?? "projectId-none___nl",
    path: noneaa5sPph2jAMeta?.path ?? "/nl/:projectId()/none",
    meta: noneaa5sPph2jAMeta || {},
    alias: noneaa5sPph2jAMeta?.alias || [],
    redirect: noneaa5sPph2jAMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: noneaa5sPph2jAMeta?.name ?? "projectId-none___fr",
    path: noneaa5sPph2jAMeta?.path ?? "/fr/:projectId()/none",
    meta: noneaa5sPph2jAMeta || {},
    alias: noneaa5sPph2jAMeta?.alias || [],
    redirect: noneaa5sPph2jAMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: noneaa5sPph2jAMeta?.name ?? "projectId-none___de",
    path: noneaa5sPph2jAMeta?.path ?? "/de/:projectId()/none",
    meta: noneaa5sPph2jAMeta || {},
    alias: noneaa5sPph2jAMeta?.alias || [],
    redirect: noneaa5sPph2jAMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: profilewRJp75aciuMeta?.name ?? "projectId-profile___en",
    path: profilewRJp75aciuMeta?.path ?? "/:projectId()/profile",
    meta: profilewRJp75aciuMeta || {},
    alias: profilewRJp75aciuMeta?.alias || [],
    redirect: profilewRJp75aciuMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profilewRJp75aciuMeta?.name ?? "projectId-profile___nl",
    path: profilewRJp75aciuMeta?.path ?? "/nl/:projectId()/profile",
    meta: profilewRJp75aciuMeta || {},
    alias: profilewRJp75aciuMeta?.alias || [],
    redirect: profilewRJp75aciuMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profilewRJp75aciuMeta?.name ?? "projectId-profile___fr",
    path: profilewRJp75aciuMeta?.path ?? "/fr/:projectId()/profile",
    meta: profilewRJp75aciuMeta || {},
    alias: profilewRJp75aciuMeta?.alias || [],
    redirect: profilewRJp75aciuMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profilewRJp75aciuMeta?.name ?? "projectId-profile___de",
    path: profilewRJp75aciuMeta?.path ?? "/de/:projectId()/profile",
    meta: profilewRJp75aciuMeta || {},
    alias: profilewRJp75aciuMeta?.alias || [],
    redirect: profilewRJp75aciuMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: imagerEfTrpcaMoMeta?.name ?? "admin-answer-answerId-image___en",
    path: imagerEfTrpcaMoMeta?.path ?? "/admin/answer/:answerId()/image",
    meta: imagerEfTrpcaMoMeta || {},
    alias: imagerEfTrpcaMoMeta?.alias || [],
    redirect: imagerEfTrpcaMoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: imagerEfTrpcaMoMeta?.name ?? "admin-answer-answerId-image___nl",
    path: imagerEfTrpcaMoMeta?.path ?? "/nl/admin/answer/:answerId()/image",
    meta: imagerEfTrpcaMoMeta || {},
    alias: imagerEfTrpcaMoMeta?.alias || [],
    redirect: imagerEfTrpcaMoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: imagerEfTrpcaMoMeta?.name ?? "admin-answer-answerId-image___fr",
    path: imagerEfTrpcaMoMeta?.path ?? "/fr/admin/answer/:answerId()/image",
    meta: imagerEfTrpcaMoMeta || {},
    alias: imagerEfTrpcaMoMeta?.alias || [],
    redirect: imagerEfTrpcaMoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: imagerEfTrpcaMoMeta?.name ?? "admin-answer-answerId-image___de",
    path: imagerEfTrpcaMoMeta?.path ?? "/de/admin/answer/:answerId()/image",
    meta: imagerEfTrpcaMoMeta || {},
    alias: imagerEfTrpcaMoMeta?.alias || [],
    redirect: imagerEfTrpcaMoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: indexLt5S1saY5zMeta?.name ?? "admin___en",
    path: indexLt5S1saY5zMeta?.path ?? "/admin",
    meta: indexLt5S1saY5zMeta || {},
    alias: indexLt5S1saY5zMeta?.alias || [],
    redirect: indexLt5S1saY5zMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexLt5S1saY5zMeta?.name ?? "admin___nl",
    path: indexLt5S1saY5zMeta?.path ?? "/nl/admin",
    meta: indexLt5S1saY5zMeta || {},
    alias: indexLt5S1saY5zMeta?.alias || [],
    redirect: indexLt5S1saY5zMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexLt5S1saY5zMeta?.name ?? "admin___fr",
    path: indexLt5S1saY5zMeta?.path ?? "/fr/admin",
    meta: indexLt5S1saY5zMeta || {},
    alias: indexLt5S1saY5zMeta?.alias || [],
    redirect: indexLt5S1saY5zMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: indexLt5S1saY5zMeta?.name ?? "admin___de",
    path: indexLt5S1saY5zMeta?.path ?? "/de/admin",
    meta: indexLt5S1saY5zMeta || {},
    alias: indexLt5S1saY5zMeta?.alias || [],
    redirect: indexLt5S1saY5zMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: aggregateEBESsddj4jMeta?.name ?? "admin-project-projectId-aggregate___en",
    path: aggregateEBESsddj4jMeta?.path ?? "/admin/project/:projectId()/aggregate",
    meta: aggregateEBESsddj4jMeta || {},
    alias: aggregateEBESsddj4jMeta?.alias || [],
    redirect: aggregateEBESsddj4jMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: aggregateEBESsddj4jMeta?.name ?? "admin-project-projectId-aggregate___nl",
    path: aggregateEBESsddj4jMeta?.path ?? "/nl/admin/project/:projectId()/aggregate",
    meta: aggregateEBESsddj4jMeta || {},
    alias: aggregateEBESsddj4jMeta?.alias || [],
    redirect: aggregateEBESsddj4jMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: aggregateEBESsddj4jMeta?.name ?? "admin-project-projectId-aggregate___fr",
    path: aggregateEBESsddj4jMeta?.path ?? "/fr/admin/project/:projectId()/aggregate",
    meta: aggregateEBESsddj4jMeta || {},
    alias: aggregateEBESsddj4jMeta?.alias || [],
    redirect: aggregateEBESsddj4jMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: aggregateEBESsddj4jMeta?.name ?? "admin-project-projectId-aggregate___de",
    path: aggregateEBESsddj4jMeta?.path ?? "/de/admin/project/:projectId()/aggregate",
    meta: aggregateEBESsddj4jMeta || {},
    alias: aggregateEBESsddj4jMeta?.alias || [],
    redirect: aggregateEBESsddj4jMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: index0W04xg0OYUMeta?.name ?? "admin-project-projectId___en",
    path: index0W04xg0OYUMeta?.path ?? "/admin/project/:projectId()",
    meta: index0W04xg0OYUMeta || {},
    alias: index0W04xg0OYUMeta?.alias || [],
    redirect: index0W04xg0OYUMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: index0W04xg0OYUMeta?.name ?? "admin-project-projectId___nl",
    path: index0W04xg0OYUMeta?.path ?? "/nl/admin/project/:projectId()",
    meta: index0W04xg0OYUMeta || {},
    alias: index0W04xg0OYUMeta?.alias || [],
    redirect: index0W04xg0OYUMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: index0W04xg0OYUMeta?.name ?? "admin-project-projectId___fr",
    path: index0W04xg0OYUMeta?.path ?? "/fr/admin/project/:projectId()",
    meta: index0W04xg0OYUMeta || {},
    alias: index0W04xg0OYUMeta?.alias || [],
    redirect: index0W04xg0OYUMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: index0W04xg0OYUMeta?.name ?? "admin-project-projectId___de",
    path: index0W04xg0OYUMeta?.path ?? "/de/admin/project/:projectId()",
    meta: index0W04xg0OYUMeta || {},
    alias: index0W04xg0OYUMeta?.alias || [],
    redirect: index0W04xg0OYUMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: resultsFLs8SOlWMpMeta?.name ?? "admin-project-projectId-results___en",
    path: resultsFLs8SOlWMpMeta?.path ?? "/admin/project/:projectId()/results",
    meta: resultsFLs8SOlWMpMeta || {},
    alias: resultsFLs8SOlWMpMeta?.alias || [],
    redirect: resultsFLs8SOlWMpMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsFLs8SOlWMpMeta?.name ?? "admin-project-projectId-results___nl",
    path: resultsFLs8SOlWMpMeta?.path ?? "/nl/admin/project/:projectId()/results",
    meta: resultsFLs8SOlWMpMeta || {},
    alias: resultsFLs8SOlWMpMeta?.alias || [],
    redirect: resultsFLs8SOlWMpMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsFLs8SOlWMpMeta?.name ?? "admin-project-projectId-results___fr",
    path: resultsFLs8SOlWMpMeta?.path ?? "/fr/admin/project/:projectId()/results",
    meta: resultsFLs8SOlWMpMeta || {},
    alias: resultsFLs8SOlWMpMeta?.alias || [],
    redirect: resultsFLs8SOlWMpMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsFLs8SOlWMpMeta?.name ?? "admin-project-projectId-results___de",
    path: resultsFLs8SOlWMpMeta?.path ?? "/de/admin/project/:projectId()/results",
    meta: resultsFLs8SOlWMpMeta || {},
    alias: resultsFLs8SOlWMpMeta?.alias || [],
    redirect: resultsFLs8SOlWMpMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93gOXfzZik9gMeta?.name ?? "admin-project-projectId-round-roundId___en",
    path: _91roundId_93gOXfzZik9gMeta?.path ?? "/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93gOXfzZik9gMeta || {},
    alias: _91roundId_93gOXfzZik9gMeta?.alias || [],
    redirect: _91roundId_93gOXfzZik9gMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93gOXfzZik9gMeta?.name ?? "admin-project-projectId-round-roundId___nl",
    path: _91roundId_93gOXfzZik9gMeta?.path ?? "/nl/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93gOXfzZik9gMeta || {},
    alias: _91roundId_93gOXfzZik9gMeta?.alias || [],
    redirect: _91roundId_93gOXfzZik9gMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93gOXfzZik9gMeta?.name ?? "admin-project-projectId-round-roundId___fr",
    path: _91roundId_93gOXfzZik9gMeta?.path ?? "/fr/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93gOXfzZik9gMeta || {},
    alias: _91roundId_93gOXfzZik9gMeta?.alias || [],
    redirect: _91roundId_93gOXfzZik9gMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93gOXfzZik9gMeta?.name ?? "admin-project-projectId-round-roundId___de",
    path: _91roundId_93gOXfzZik9gMeta?.path ?? "/de/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93gOXfzZik9gMeta || {},
    alias: _91roundId_93gOXfzZik9gMeta?.alias || [],
    redirect: _91roundId_93gOXfzZik9gMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: createLnp3A3SH9WMeta?.name ?? "admin-project-projectId-round-create___en",
    path: createLnp3A3SH9WMeta?.path ?? "/admin/project/:projectId()/round/create",
    meta: createLnp3A3SH9WMeta || {},
    alias: createLnp3A3SH9WMeta?.alias || [],
    redirect: createLnp3A3SH9WMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: createLnp3A3SH9WMeta?.name ?? "admin-project-projectId-round-create___nl",
    path: createLnp3A3SH9WMeta?.path ?? "/nl/admin/project/:projectId()/round/create",
    meta: createLnp3A3SH9WMeta || {},
    alias: createLnp3A3SH9WMeta?.alias || [],
    redirect: createLnp3A3SH9WMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: createLnp3A3SH9WMeta?.name ?? "admin-project-projectId-round-create___fr",
    path: createLnp3A3SH9WMeta?.path ?? "/fr/admin/project/:projectId()/round/create",
    meta: createLnp3A3SH9WMeta || {},
    alias: createLnp3A3SH9WMeta?.alias || [],
    redirect: createLnp3A3SH9WMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: createLnp3A3SH9WMeta?.name ?? "admin-project-projectId-round-create___de",
    path: createLnp3A3SH9WMeta?.path ?? "/de/admin/project/:projectId()/round/create",
    meta: createLnp3A3SH9WMeta || {},
    alias: createLnp3A3SH9WMeta?.alias || [],
    redirect: createLnp3A3SH9WMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: createy5OSSYznPFMeta?.name ?? "admin-project-create___en",
    path: createy5OSSYznPFMeta?.path ?? "/admin/project/create",
    meta: createy5OSSYznPFMeta || {},
    alias: createy5OSSYznPFMeta?.alias || [],
    redirect: createy5OSSYznPFMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: createy5OSSYznPFMeta?.name ?? "admin-project-create___nl",
    path: createy5OSSYznPFMeta?.path ?? "/nl/admin/project/create",
    meta: createy5OSSYznPFMeta || {},
    alias: createy5OSSYznPFMeta?.alias || [],
    redirect: createy5OSSYznPFMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: createy5OSSYznPFMeta?.name ?? "admin-project-create___fr",
    path: createy5OSSYznPFMeta?.path ?? "/fr/admin/project/create",
    meta: createy5OSSYznPFMeta || {},
    alias: createy5OSSYznPFMeta?.alias || [],
    redirect: createy5OSSYznPFMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: createy5OSSYznPFMeta?.name ?? "admin-project-create___de",
    path: createy5OSSYznPFMeta?.path ?? "/de/admin/project/create",
    meta: createy5OSSYznPFMeta || {},
    alias: createy5OSSYznPFMeta?.alias || [],
    redirect: createy5OSSYznPFMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: indexI29PzlnlzfMeta?.name ?? "index___en",
    path: indexI29PzlnlzfMeta?.path ?? "/",
    meta: indexI29PzlnlzfMeta || {},
    alias: indexI29PzlnlzfMeta?.alias || [],
    redirect: indexI29PzlnlzfMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexI29PzlnlzfMeta?.name ?? "index___nl",
    path: indexI29PzlnlzfMeta?.path ?? "/nl",
    meta: indexI29PzlnlzfMeta || {},
    alias: indexI29PzlnlzfMeta?.alias || [],
    redirect: indexI29PzlnlzfMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexI29PzlnlzfMeta?.name ?? "index___fr",
    path: indexI29PzlnlzfMeta?.path ?? "/fr",
    meta: indexI29PzlnlzfMeta || {},
    alias: indexI29PzlnlzfMeta?.alias || [],
    redirect: indexI29PzlnlzfMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexI29PzlnlzfMeta?.name ?? "index___de",
    path: indexI29PzlnlzfMeta?.path ?? "/de",
    meta: indexI29PzlnlzfMeta || {},
    alias: indexI29PzlnlzfMeta?.alias || [],
    redirect: indexI29PzlnlzfMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: logineGe6N4CpIoMeta?.name ?? "login___en",
    path: logineGe6N4CpIoMeta?.path ?? "/login",
    meta: logineGe6N4CpIoMeta || {},
    alias: logineGe6N4CpIoMeta?.alias || [],
    redirect: logineGe6N4CpIoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: logineGe6N4CpIoMeta?.name ?? "login___nl",
    path: logineGe6N4CpIoMeta?.path ?? "/nl/login",
    meta: logineGe6N4CpIoMeta || {},
    alias: logineGe6N4CpIoMeta?.alias || [],
    redirect: logineGe6N4CpIoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: logineGe6N4CpIoMeta?.name ?? "login___fr",
    path: logineGe6N4CpIoMeta?.path ?? "/fr/login",
    meta: logineGe6N4CpIoMeta || {},
    alias: logineGe6N4CpIoMeta?.alias || [],
    redirect: logineGe6N4CpIoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: logineGe6N4CpIoMeta?.name ?? "login___de",
    path: logineGe6N4CpIoMeta?.path ?? "/de/login",
    meta: logineGe6N4CpIoMeta || {},
    alias: logineGe6N4CpIoMeta?.alias || [],
    redirect: logineGe6N4CpIoMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: registerIENyPaptVvMeta?.name ?? "register___en",
    path: registerIENyPaptVvMeta?.path ?? "/register",
    meta: registerIENyPaptVvMeta || {},
    alias: registerIENyPaptVvMeta?.alias || [],
    redirect: registerIENyPaptVvMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerIENyPaptVvMeta?.name ?? "register___nl",
    path: registerIENyPaptVvMeta?.path ?? "/nl/register",
    meta: registerIENyPaptVvMeta || {},
    alias: registerIENyPaptVvMeta?.alias || [],
    redirect: registerIENyPaptVvMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerIENyPaptVvMeta?.name ?? "register___fr",
    path: registerIENyPaptVvMeta?.path ?? "/fr/register",
    meta: registerIENyPaptVvMeta || {},
    alias: registerIENyPaptVvMeta?.alias || [],
    redirect: registerIENyPaptVvMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerIENyPaptVvMeta?.name ?? "register___de",
    path: registerIENyPaptVvMeta?.path ?? "/de/register",
    meta: registerIENyPaptVvMeta || {},
    alias: registerIENyPaptVvMeta?.alias || [],
    redirect: registerIENyPaptVvMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src2814414732/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  }
]